import _ from "underscore";
import { TweenMax, Power4 } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import Abstract from "../../framework/Abstract";

import "./C4-accordion.scss";

class C4Accordion extends Abstract {
    init() {
        this.scrollToPlugin = ScrollToPlugin; // Preventing tree-shaking.
        this.tweenDuration = 0.5;
        this.select = this.root.querySelector(".select");
        this.accordionItems = Array.from(
            this.root.querySelectorAll(".C4-accordion__item")
        );
        this.activeAccordionItem = null;

        this.accordionItems.forEach((accordionItem) => {
            const accordionItemTitle = accordionItem.getElementsByClassName(
                "C4-accordion__item__title"
            )[0];
            const accordionItemArrow = accordionItem.getElementsByClassName(
                "C4-accordion__item__arrow-icon"
            )[0];

            accordionItemTitle.addEventListener(
                "click",
                () => {
                    this.animateAccordion(accordionItem);
                },
                false
            );

            accordionItemArrow.addEventListener(
                "click",
                () => {
                    this.animateAccordion(accordionItem);
                },
                false
            );
        });

        this.select.addEventListener(
            "change",
            this.updateCategory.bind(this),
            false
        );

        const selectOptions = this.select.getElementsByTagName("option");
        Array.from(selectOptions).forEach((option) => {
            const { selected } = option.dataset;
            if (selected === "true") {
                this.select.value = option.value;
                this.updateCategory({ target: this.select });
            }
        });
    }

    updateCategory(e) {
        if (this.activeAccordionItem) {
            this.closeAccordionItem(this.activeAccordionItem);
        }

        if (e.target.value === "") {
            TweenMax.set(this.accordionItems, { display: "block" });
            return;
        }

        TweenMax.set(this.accordionItems, { display: "none" });

        _.each(this.accordionItems, (accordionItem) => {
            if (
                e.target[e.target.selectedIndex].value ===
                accordionItem.dataset.option
            ) {
                TweenMax.set(accordionItem, { display: "block" });
            }
        });
    }

    animateAccordion(item) {
        if (item.classList.contains("is-active")) {
            this.closeAccordionItem(item);
        } else {
            if (this.activeAccordionItem && this.activeAccordionItem !== item) {
                this.closeAccordionItem(this.activeAccordionItem);
            }
            this.openAccordionItem(item);
            this.activeAccordionItem = item;
        }
    }

    openAccordionItem(item) {
        const itemTitle = item.getElementsByClassName(
            "C4-accordion__item__title"
        )[0];
        const itemContent = item.getElementsByClassName(
            "C4-accordion__item__content"
        )[0];
        const itemArrow = item.getElementsByClassName(
            "C4-accordion__item__arrow-icon"
        )[0];

        item.classList.add("is-active");
        TweenMax.to(window, this.tweenDuration / 2, {
            delay: this.tweenDuration / 2,
            scrollTo: { y: item, offsetY: 56, ease: Power4.easeOut },
        });
        TweenMax.to(itemTitle, this.tweenDuration, {
            marginBottom: 56,
            ease: Power4.easeOut,
        });
        TweenMax.to(itemArrow, this.tweenDuration, {
            rotation: -90,
            ease: Power4.easeOut,
            transformOrigin: "50% 50%",
        });
        TweenMax.set(itemContent, { height: "auto" });
        TweenMax.from(itemContent, this.tweenDuration, {
            height: 0,
            ease: Power4.easeOut,
        });
    }

    closeAccordionItem(item) {
        const itemTitle = item.getElementsByClassName(
            "C4-accordion__item__title"
        )[0];
        const itemContent = item.getElementsByClassName(
            "C4-accordion__item__content"
        )[0];
        const itemArrow = item.getElementsByClassName(
            "C4-accordion__item__arrow-icon"
        )[0];

        item.classList.remove("is-active");
        TweenMax.to(itemTitle, this.tweenDuration, {
            marginBottom: 0,
            ease: Power4.easeOut,
        });
        TweenMax.to(itemArrow, this.tweenDuration, {
            rotation: 90,
            ease: Power4.easeOut,
            transformOrigin: "50% 50%",
        });
        TweenMax.to(itemContent, this.tweenDuration, {
            height: 0,
            ease: Power4.easeOut,
        });
    }
}

export default C4Accordion;
